import { render, staticRenderFns } from "./b2b-dialog-lido.vue?vue&type=template&id=1981815a&scoped=true"
import script from "./b2b-dialog-lido.vue?vue&type=script&lang=js"
export * from "./b2b-dialog-lido.vue?vue&type=script&lang=js"
import style0 from "./b2b-dialog-lido.vue?vue&type=style&index=0&id=1981815a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981815a",
  null
  
)

export default component.exports